export default function ($) {

    var url = window.location.href;
    var cleanUrl = url.replace(/([^:]\/)\/+/g, "$1");
    history.replaceState(null, null, cleanUrl);

}
